import { Empty } from 'antd';

const DEFAULT_IMAGE = Empty.PRESENTED_IMAGE_SIMPLE;

const emptyConfigs = {
  Select: {
    description: 'No hay opciones disponibles',
    style: { marginBlock: 8 },
    styles: { image: { height: '2em' } },
  },
};

export const renderEmpty = (componentName) => {
  const config = emptyConfigs[componentName];
  if (!config) return undefined; // Usa la configuración por defecto si no se proporciona una configuración personalizada

  return <Empty image={DEFAULT_IMAGE} {...config} />
}